import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["enabled", "hours", "dates"]
  connect() { this.toggle() }
  toggle() { this.hoursTarget.hidden = !this.enabledTarget.checked }
  addDate() {
    const index = this.datesTarget.children.length
    const row = this.datesTarget.lastElementChild.cloneNode(true)
    for (const input of row.querySelectorAll("input")) {
      input.value = ""
      input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
      input.setAttribute("aria-label", `Override ${input.type === "date" ? "date" : "hours"} ${index + 1}`)
    }
    this.datesTarget.append(row)
    row.querySelector("input").focus()
  }
}
